export const GET_VISITOR_LIST_REQUEST = 'GET_VISITOR_LIST_REQUEST';
export const GET_VISITOR_LIST_SUCCESS = 'GET_VISITOR_LIST_SUCCESS';
export const GET_VISITOR_LIST_FAILURE = 'GET_VISITOR_LIST_FAILURE';

export const GET_VISITOR_LIST_BY_ID_REQUEST = 'GET_VISITOR_LIST_BY_ID_REQUEST';
export const GET_VISITOR_LIST_BY_ID_SUCCESS = 'GET_VISITOR_LIST_BY_ID_SUCCESS';
export const GET_VISITOR_LIST_BY_ID_FAILURE = 'GET_VISITOR_LIST_BY_ID_FAILURE';

export const CREATE_VISITOR_REQUEST = 'CREATE_VISITOR_REQUEST';
export const CREATE_VISITOR_SUCCESS = 'CREATE_VISITOR_SUCCESS';
export const CREATE_VISITOR_FAILURE = 'CREATE_VISITOR_FAILURE';

export const EDIT_VISITOR_REQUEST = ' EDIT_VISITOR_REQUEST';
export const EDIT_VISITOR_SUCCESS = 'EDIT_VISITOR_SUCCESS';
export const EDIT_VISITOR_FAILURE = 'EDIT_VISITOR_FAILURE';
export const CLEAR_VISITOR_DATA = 'CLEAR_VISITOR_DATA';
